import { Injectable } from "@angular/core";
import { VideoplayerComponent } from "../videoplayer/videoplayer.component";
import { VideoFilterService } from "./video-filter.service";
import { MediaManagerService } from "./media-manager.service";

@Injectable({
    providedIn: "root",
})
export class VideoService {
    

    videoPlayer!: VideoplayerComponent;

    remoteMediaStream!: MediaStream;
    outputMediaStream!: MediaStream;
    localMediaStream!: MediaStream;
    filters: {service: VideoFilterService, args: string[], params: any}[] = [];
    managers: {service: MediaManagerService, params: any}[] = [];


    constructor() {}

    setup(videoPlayer: VideoplayerComponent) {
        this.remoteMediaStream = new MediaStream();
        this.localMediaStream = new MediaStream();
        this.videoPlayer = videoPlayer;
    }

    setPlayer(videoPlayer: VideoplayerComponent) {
      this.videoPlayer = videoPlayer;
    }

    setVideoMediaSource() {
    //   this.videoPlayer.setVideoMediaStream(this.remoteMediaStream);
        this.outputMediaStream = this.applyFilters();
        this.videoPlayer?.setVideoMediaStream(this.outputMediaStream);

        this.managers.forEach((manager: {service: MediaManagerService, params: any}) => {
          manager.service.setRemoteMediaStream(this.outputMediaStream);
          manager.service.setLocalMediaStream(this.localMediaStream);
        })
    }

    applyFilters() {
      let mediaStream = this.remoteMediaStream;
      console.log('VIDEOSERVICE applyFilters', mediaStream, mediaStream?.getTracks());
      this.filters.forEach((filter: {service: VideoFilterService, args: string[], params: any}) => {
        mediaStream = filter.service.applyFilter(mediaStream, filter.args, filter.params);
      })
      console.log('VIDEOSERVICE applyFilters result', mediaStream, mediaStream?.getTracks());
      return mediaStream;
    }

    addTrack(track: MediaStreamTrack, isRemote: boolean) {
      console.log('VIDEOSERVICE addTrack', track, isRemote);
      if(isRemote) {
        this.remoteMediaStream.addTrack(track);
        this.setVideoMediaSource();
      }
      else {
        this.localMediaStream.addTrack(track);
      }
    }

    removeTrack(track: MediaStreamTrack, isRemote: boolean) {
      if(isRemote) {
        this.remoteMediaStream.removeTrack(track);
      }
      else {
        this.localMediaStream.removeTrack(track);
      }
    }

    removeAllTracks(isRemote: boolean) {
      if(isRemote) {
        this.remoteMediaStream.getTracks().forEach(track => this.remoteMediaStream.removeTrack(track));
        this.setVideoMediaSource();
      }
      else {
        this.localMediaStream.getTracks().forEach(track => this.localMediaStream.removeTrack(track));
      }
    }

    addFilter(filter: VideoFilterService, args: string[], params: any) {
      this.filters.push({service: filter, args: args, params: params});
      this.setVideoMediaSource();
    }

    removeFilter(filter: VideoFilterService) {
        filter.removeFilter(this.outputMediaStream);
      this.filters = this.filters.filter(f => f.service !== filter);
      this.setVideoMediaSource();
    }

    removeAllFilters() {
      this.filters.forEach((filter: {service: VideoFilterService, args: string[], params: any}) => {
        filter.service.removeFilter(this.outputMediaStream);
      })
      this.filters = [];
    }

    addManager(manager: MediaManagerService, params: any) {
      this.managers.push({service: manager, params: params});
      this.setVideoMediaSource();
    }

    removeManager(manager: MediaManagerService) {
      this.managers = this.managers.filter(m => m.service !== manager);
      this.setVideoMediaSource();
    }

}